import script from "./AdminPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminPage.vue?vue&type=script&lang=ts&setup=true"

import "./AdminPage.vue?vue&type=style&index=0&id=4d8a7172&scope=true&lang=css"

const __exports__ = script;

export default __exports__